<template>
  <div class="appContainer container-fluid">
    <div class="appNavbar">
      <Navbar></Navbar>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>

    <notifications group="errors" />
    <notifications group="successes" />
  </div>
</template>

<script>
import { eventBus } from "@/_infrastructure";
import Navbar from "./Navbar.vue";

export default {
  components: {
    Navbar
  },
  methods: {
    notifyAboutError(error) {
      this.$notify({
        speed: 1,
        type: "error",
        group: "errors",
        title: "Błąd",
        text: error
      });
    },
    notifyAboutSucces(text) {
      this.$notify({
        speed: 1,
        type: "success",
        group: "successes",
        title: "Sukces",
        text: text
      });
    }
  },
  created() {
    var _self = this;

    eventBus.$on("unhandled-error", function(error) {
      var errorMsg = "Wystąpił nieokreślony błąd";

      if (error) {
        errorMsg = error;
      }

      if (error.response) {
        var errorData = error.response.data;
        // tak, wielkosc znakow jest gdzies skopana..... Message z wielkiej, errors z malej
        if (errorData.Message) {
          errorMsg = errorData.Message;
        } else if (errorData.errors) {
          let tempMsg = "";
          for (var p in errorData.errors) {
            for (var pp in errorData.errors[p]) {
              tempMsg += errorData.errors[p][pp] + "<br/>";
            }
          }
          errorMsg = tempMsg;
        } else if (errorData) {
          errorMsg = errorData;
        }
      }

      _self.notifyAboutError(errorMsg);
    });
    eventBus.$on("notify-success", function(text) {
      _self.notifyAboutSucces(text);
    });
  },
  destroyed() {
    eventBus.$off("unhandled-error");
    eventBus.$off("notify-success");
  }
};
</script>

<style lang="scss" scoped>
.container-fluid {
  margin: 0px;
  padding: 0px;
}

.content {
  margin: 15px;
}
</style>
